import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc6665f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-card" }
const _hoisted_2 = { class: "course-card__information" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "course-card__img" }, null, -1))
const _hoisted_4 = { class: "course-card__title" }
const _hoisted_5 = { class: "course-card__fade fadeInUp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.course.title), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToCourse())),
          onMousemove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, "Continuar", 32)
      ])
    ]),
    _createVNode(_component_ProgressBar, {
      "filled-percentage": _ctx.course.courseProgress
    }, null, 8, ["filled-percentage"])
  ]))
}